<div
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2 sp-table__sticky-header">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'COMPANIES.CONTRACTS_DETAILS_TITLE' | translate }}</h3>
    </div>
  </div>
  <div *ngIf="contracts?.length">
    <div *ngFor="let contract of contracts">
      <div class="sp-margin__bottom sp-row__space sp-wrap">
        <div
          class="sp-border-radius sp-padding__horiz sp-hidden__before-md sp-margin__right"
          [ngClass]="getContractStatusBackgroundClass(contract)">
          <span [ngClass]="getContractStatusColorClass(contract)">
            {{ contract.status | lowercase }}
          </span>
        </div>

        <div
          class="sp-circle__s sp-hidden__after-md sp-margin__right"
          [ngClass]="getContractStatusBackgroundClass(contract)"></div>

        <div class="sp-row__align">
          <mat-icon
            *ngIf="isContractSigned(contract) || isContractAccepted(contract)"
            (click)="onAcceptContractClick(contract)"
            [matTooltip]="'COMPANIES.APPROVE_CONTRACT_CTA' | translate"
            class="material-symbols-outlined sp-cursor__pointer sp-margin__right"
            color="primary">
            check_circle
          </mat-icon>
          <mat-icon
            *ngIf="isContractSigned(contract) || isContractAccepted(contract)"
            (click)="onDenyContractClick(contract)"
            [matTooltip]="'COMPANIES.DENY_CONTRACT_CTA' | translate"
            class="material-symbols-outlined sp-cursor__pointer sp-margin__right"
            color="accent">
            cancel
          </mat-icon>

          <button
            *ngIf="!is_contract_download_loading"
            (click)="onContractClick(contract)"
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__right"
            [matTooltip]="'COMPANIES.CONTRACT_VIEW_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> picture_as_pdf </mat-icon>
          </button>

          <mat-spinner
            *ngIf="is_contract_download_loading"
            class="sp-margin__right"
            color="primary"
            diameter="20"></mat-spinner>

          <button
            mat-icon-button
            class="sp-icon__button sp-icon__button-warn"
            [matTooltip]="'GENERAL.DELETE_CTA' | translate"
            (click)="onDeleteClick(contract)">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
          </button>
        </div>
        <hr
          class="sp-width__full sp-stroke sp-stroke__dashed-dark"
          style="margin-top: 4px" />
      </div>
      <div
        class="sp-width__full sp-margin__top-x4 sp-company-details-general-contracts__grid sp-grid__column-gap-x2 sp-grid__row-gap">
        <app-shared-info
          [label]="'COMPANIES.CONTRACTS_UPLOAD_DATE_TITLE'"
          [content]="(contract?.created_at | date : 'short') ?? '-'"
          [content_class]="'sp-text__ellipsized'"></app-shared-info>
        <app-shared-info
          [label]="'COMPANIES.CONTRACTS_ACCEPTED_BY_TITLE'"
          [content]="contract?.accepted_by || '-'"
          [content_class]="'sp-text__ellipsized'"></app-shared-info>
      </div>
    </div>
  </div>
  <div
    *ngIf="!contracts?.length"
    class="sp-width__full sp-margin__top-x4 sp-company-details-general-contracts__form sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-empty-message [empty_message]="'COMPANIES.CONTRACT_EMPTY_LABEL'"></app-shared-empty-message>
    <form
      [formGroup]="create_contract_from_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'COMPANIES.SALES_NETWORK_ID_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="sales_network_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'COMPANIES.CONTRACT_GENERATE_CTA'"
        [is_disabled]="!isFormValid() || is_generate_running"
        [is_spinner_visible]="is_generate_running"
        (click)="onNewContractClick()"></app-shared-button>
    </form>
  </div>
</div>
